module.exports = __webpack_public_path__ + "static/media/ca_logo.c274cd28.png";